// import state from "sweetalert/typings/modules/state";
import { EMP_ATTENDANCE } from "../action_types";
const initialstate = {
  emp_id: '',
  date: '',
  data: {},
  in_out: {},
  today_att_time: {},
  In_time: '',
  month_att_time: '',
  week_att_time: '',
  Today_HRS: 0,
  User_Presents: 0,
  todayInOutTime: {}
}
export const attendenace = (state = initialstate, { type, payload }) => {
  switch (type) {
    case EMP_ATTENDANCE: {
      return {
        ...state,
        data: payload
      };
    }
    case 'EMP_TODAT_ATTENDANCE_TIME': {
      return {
        ...state,
        today_att_time: payload?.today_time,
      };
    }

    case 'SET_EMP_PUNCH_TIME_IN': {
      return {
        ...state,
        In_time: payload,
      };
    }
    case 'SET_EMP_PUNCH_TIME_IN_MONTH': {
      return {
        ...state,
        month_att_time: payload?.response,
      }
    }
    case 'SET_EMP_PUNCH_TIME_IN_WEEK': {
      return {
        ...state,
        week_att_time: payload?.week_hrs,
      }
    }
    case 'SET_COMPANY_HOLIDAY': {
      return {
        ...state,
        company_holiday: payload?.holiday,
      };
    }
    case 'SET_EMP_PRESENTS_IN_MONTH': {
      return {
        ...state,
        user_presents: payload?.present,
      };
    }
    case 'SET_ATTENDANCE_CLEAN': {
      return {
        data: payload,
        In_time: '',
        emp_id: '',
        date: '',
        in_out: {},
        today_att_time: {},
        month_att_time: '',
        week_att_time: '',
      };
    }
    case 'SET_USER_TODAY_HRS': {
      return {
        ...state,
        Today_HRS: payload?.TOTAL_HRS

      }
    }
    case 'EMP_IN_OUT_TIME_IN': {
      return {
        ...state,
        todayInOutTime: payload
      }
    }

    default: {
      return state;
    }

  }
}